module.exports = __webpack_public_path__ + "static/img/3b.f1e184d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/3b.jpg
// module id = jseL
// module chunks = 0